export const Header = (props) => {
  return (
    <header id='header'>
      <div className='intro'>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-8 col-md-offset-2 intro-text'>
                <h1>
                  {props.data ? props.data.title : 'Betöltés'}
                  <span></span>
                </h1>
                <h2 className="subtitle">
                  {props.data ? props.data.subtitle : 'Betöltés'}
                  <span></span>
                </h2>
                <p>{props.data ? props.data.paragraph : 'Betöltés'}</p>
                <a target="_blank"
                  href='http://www.metaautoszerviz.hu'
                  className='btn btn-custom btn-lg page-scroll'
                >
                 <h3 className="gomb"> <b>Tudj meg többet</b> </h3>
                </a>{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
